import React from "react"
import styles from "./statusPaid.module.css"
import Logo from '../../../../logo.svg'
import { TbAlertTriangle, TbArrowBackUp, TbCircleCheck, TbHome, TbRefresh } from "react-icons/tb"

const StatusPaid = ({ paid = false, invalid = false, message = "", onRetry = null }) => {
    const appUrl = process.env.REACT_APP_HOST || "/"
    const status = paid ? "success" : "error"
    const title = paid ? "Pagamento aprovado" : "Cobrança indisponível"
    const description = paid
        ? "Recebemos a confirmação do pagamento. A fatura foi baixada e a nota fiscal ficará disponível em Minha Conta quando emitida."
        : (message || "Não foi possível localizar ou abrir esta cobrança. Ela pode ter sido paga, cancelada, expirada ou o link pode estar incorreto.")

    return (
        <div className={`${styles.body} ${styles[status]}`}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <img className={styles.logo} src={Logo} alt="Logo Oktto" />
                    <span>{paid ? "Financeiro" : "Aviso do sistema"}</span>
                </div>
                <div className={styles.statusIcon}>
                    {paid ? <TbCircleCheck /> : <TbAlertTriangle />}
                </div>
                <div className={styles.text}>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </div>
                {invalid &&
                    <div className={styles.helpBox}>
                        <strong>O que conferir</strong>
                        <span>Verifique se o link foi copiado completo, se a cobrança ainda está em aberto ou acesse a área financeira da conta.</span>
                    </div>
                }
                <div className={styles.actions}>
                    {onRetry &&
                        <button type="button" className={styles.secondaryAction} onClick={onRetry}>
                            <TbRefresh />Tentar novamente
                        </button>
                    }
                    <a className={styles.primaryAction} href={appUrl}>
                        {paid ? <TbHome /> : <TbArrowBackUp />}
                        {paid ? "Acessar Oktto" : "Voltar ao sistema"}
                    </a>
                </div>
            </div>
        </div>
    )
}

export default StatusPaid
